/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/FactBox/theme';

export const FactBoxTheme = theme;
